
/**
 * Module dependencies.
 */

import airchatIcon from './assets/32/airchat.svg';
import discordIcon from './assets/32/discord.svg';
import facebookIcon from './assets/32/facebook.svg';
import instagramIcon from './assets/32/instagram.svg';
import linkedinIcon from './assets/32/linkedin.svg';
import mediumIcon from './assets/32/medium.svg';
import slackIcon from './assets/32/slack.svg';
import substackIcon from './assets/32/substack.svg';
import telegramIcon from './assets/32/telegram.svg';
import tiktokIcon from './assets/32/tiktok.svg';
import twitterIcon from './assets/32/twitter.svg';

/**
 * Export `socialNetworksIcons`.
 */

export const socialNetworksIcons = {
  airchat: airchatIcon,
  discord: discordIcon,
  facebook: facebookIcon,
  instagram: instagramIcon,
  linkedin: linkedinIcon,
  medium: mediumIcon,
  slack: slackIcon,
  substack: substackIcon,
  telegram: telegramIcon,
  tiktok: tiktokIcon,
  twitter: twitterIcon
};
